import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Lib from '../../../commons/lib';
import FizetesimodLista from './FizetesimodLista';
import PenznemLista from './PenznemLista';
import InflacioLista from './InflacioLista';
import BankszamlaLista from './BankszamlaLista';
import BanktipusLista from './BanktipusLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './PenzugyTooltips';


class PenzMenuBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = '1';
    if (this.props.globals.hasRole(['BANK_PENZTAR'])) activeTab = '6';
    if (this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA'])) activeTab = '5';
    if (this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS'])) activeTab = '4';
    if (this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO'])) activeTab = '3';
    if (this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM'])) activeTab = '2';
    if (this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD'])) activeTab = '1';
    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {'Pénzügyi adatok'}
              <CustomTooltip text={getTooltip('penzugy')} id="penzugyTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD']) && (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => {
                            this.toggle('1');
                            if (this.child1) this.child1.updateTable();
                          }}
                        >
                          {'Fizetési mód'}
                          <CustomTooltip text={getTooltip('fizetesimod')} id="fizetesimodTT" />
                        </NavLink>
                      </NavItem>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM']) && (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => {
                            this.toggle('2');
                            if (this.child2) this.child2.updateTable();
                          }}
                        >
                          {'Pénznem'}
                          <CustomTooltip text={getTooltip('penznem')} id="penznemTT" />
                        </NavLink>
                      </NavItem>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO']) && (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => {
                            this.toggle('3');
                            if (this.child3) this.child3.updateTable();
                          }}
                        >
                          {'Infláció'}
                          <CustomTooltip text={getTooltip('inflacio')} id="inflacioTT" />
                        </NavLink>
                      </NavItem>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS']) && (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '4' })}
                          onClick={() => {
                            this.toggle('4');
                            if (this.child4) this.child4.updateTable();
                          }}
                        >
                          {'Banktípus'}
                          <CustomTooltip text={getTooltip('banktipus')} id="banktipusTT" />
                        </NavLink>
                      </NavItem>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA']) && (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '5' })}
                          onClick={() => {
                            this.toggle('5');
                            if (this.child5) this.child5.queryAllPenzugyValues();
                          }}
                        >
                          {'Bankszámla'}
                          <CustomTooltip text={getTooltip('bankszamla')} id="bamkszamlaTT" />
                        </NavLink>
                      </NavItem>
                    )}
                </Nav>
                {
                  (this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD'])
                || this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM'])
                || this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO'])
                || this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS'])
                || this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA'])) && (
                <TabContent activeTab={this.state.activeTab}>
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD']) && (
                      <TabPane tabId="1">
                        <FizetesimodLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child1 = instance; }}
                          active={this.state.activeTab === '1'}
                        />
                      </TabPane>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM']) && (
                      <TabPane tabId="2">
                        <PenznemLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child2 = instance; }}
                          active={this.state.activeTab === '2'}
                        />
                      </TabPane>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO']) && (
                      <TabPane tabId="3">
                        <InflacioLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child3 = instance; }}
                          active={this.state.activeTab === '3'}
                        />
                      </TabPane>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS']) && (
                      <TabPane tabId="4">
                        <BanktipusLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child4 = instance; }}
                          active={this.state.activeTab === '4'}
                        />
                      </TabPane>
                    )}
                  {
                    this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA']) && (
                      <TabPane tabId="5">
                        <BankszamlaLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child5 = instance; }}
                          active={this.state.activeTab === '5'}
                        />
                      </TabPane>
                    )}
                </TabContent>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PenzMenuBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default PenzMenuBase;
